import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingHorizontal: 53,
    paddingVertical: 20,
  },
  columnContainer: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    gap: 20,
  },
  leftColumn: {
    flex: 1,
    padding: 10,
  },
  middleColumn: {
    flex: 1,
    padding: 10,
  },
  rightColumn: {
    flex: 1,
    padding: 10,
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    textTransform: 'uppercase',
    width: '60%',
  },
  columnContent: {
    backgroundColor: '#F5F5F5',
    border: '3px solid #EDEDED',
    borderRadius: '10px',
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  columnTitle: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 30,
    marginBottom: 8,
    color: '#27343d',
  },
  listItem: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    lineHeight: 1.2,
    marginBottom: 2,
  },

  buyNowWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 10,
    width: '100%',

    marginTop: 20,
  },
  priceText: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 20,
  },
  excludeVATText: {
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 12,
  },
  ticketButton: {
    borderRadius: '5px',
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 16,
    textAlign: 'center',
    textDecoration: 'none',

    width: 120,
    paddingVertical: 8,
    paddingHorizontal: 10,
    marginTop: 20,
  },
});
